import React from 'react';

export const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-ivory to-cream py-20" data-testid="about-page">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl md:text-6xl font-bold text-maroon mb-4">About Digjaya Ghaisas</h1>
          <div className="w-24 h-1 bg-gold mx-auto mt-6"></div>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Photo */}
            <div className="fade-in">
              <div className="bg-white rounded-lg shadow-lg p-4">
                <img
                  src="/assets/about-artist.jpg"
                  alt="Digjaya Ghaisas in Bharatanatyam costume"
                  className="w-full rounded-md object-cover"
                  data-testid="about-artist-photo"
                />
              </div>
            </div>

            {/* Bio */}
            <div className="space-y-6 fade-in">
              <div className="bg-white rounded-lg shadow-lg p-8">
                <p className="text-maroon-dark leading-relaxed text-base md:text-lg mb-6" data-testid="about-bio-intro">
                  Welcome! I am Digjaya Ghaisas, a devoted Bharatanatyam artist, educator, and certified
                  Dance Movement Therapy facilitator. My path in dance blossomed with my Arangetram in 2015,
                  followed by earning my Master’s degree in Bharatanatyam from Kavikulaguru Kalidas Sanskrit
                  Vishwavidyalaya under the revered guidance of Guru Dr. Sandhya Purecha. Over the years, I have
                  graced diverse cultural stages, weaving timeless melodies and sacred rhythms into expressive
                  visual poetry.
                </p>
                <p className="text-maroon-dark leading-relaxed text-base md:text-lg" data-testid="about-bio-studio">
                  Within my studio, I blend classical precision with heartfelt devotion, guiding learners through
                  the graceful harmony of footwork, rhythm, and nuanced abhinaya. As a facilitator certified in
                  Dance Movement Therapy from Sancheti Healthcare Academy, I enrich traditional training with
                  mindful body awareness and emotional poise. Here, every student discovers not merely the art
                  of dance, but an empowering sanctuary of poise, joy, and inner expression.
                </p>
              </div>

              {/* Highlights */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg shadow-md p-5 text-center" data-testid="about-highlight-arangetram">
                  <p className="text-2xl font-bold text-gold">2015</p>
                  <p className="text-sm text-maroon-dark mt-1">Arangetram</p>
                </div>
                <div className="bg-white rounded-lg shadow-md p-5 text-center" data-testid="about-highlight-masters">
                  <p className="text-2xl font-bold text-gold">Master’s</p>
                  <p className="text-sm text-maroon-dark mt-1">Bharatanatyam, Kavikulaguru Kalidas Sanskrit Vishwavidyalaya</p>
                </div>
                <div className="bg-white rounded-lg shadow-md p-5 text-center" data-testid="about-highlight-guru">
                  <p className="text-2xl font-bold text-gold">Guru</p>
                  <p className="text-sm text-maroon-dark mt-1">Guidance of Guru Dr. Sandhya Purecha</p>
                </div>
                <div className="bg-white rounded-lg shadow-md p-5 text-center" data-testid="about-highlight-dmt">
                  <p className="text-2xl font-bold text-gold">Certified</p>
                  <p className="text-sm text-maroon-dark mt-1">Dance Movement Therapy, Sancheti Healthcare Academy</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
